import { ICapacityPublic } from "@/store/types/control-types";
import { General } from "./constants";

export const partUnitFormatter = (description: string) => {
  const formatedText = /([\w-]{1,30})\/([\w-]{1,30})\/(([\w-]{1,30}( -[\w- ]{1,30})?)) -/g.exec(
    description
  );

  if (formatedText) {
    const [, part, , unity] = formatedText;
    return `${part}/${unity}`;
  }
  return description;
};

export const capacityThreeAbbreviationFormatter = (
  _capacity: ICapacityPublic,
  description = true,
  status = true
) => {
  const stateText = _capacity.active
    ? General.ACTIVE_MASC
    : General.INACTIVE_MASC;
  return (
    `${_capacity.entity.abbreviation}/${
      _capacity.abbreviation.includes(_capacity.entity.abbreviation)
        ? _capacity.abbreviation.split("/")[1]
        : _capacity.abbreviation
    }`.toUpperCase() +
    (description ? ` - ${_capacity.description}`.toUpperCase() : "") +
    (status ? ` - ${stateText}` : "")
  );
};
